import { TEST_STATUSES } from '../../../constants';
import { TStatuses } from '../../../types';

interface ExecutionParams {
  [key: string]: any;
  status: Exclude<TStatuses, 'EMPTY'>;
}

export const statusFunc = (execution: ExecutionParams | null | undefined) => {
  return execution?.status ? execution.status : TEST_STATUSES.EMPTY;
};

export const isLoadingFunc = (status: string) => {
  return status === TEST_STATUSES.RUNNING || status === TEST_STATUSES.CREATED;
};
